export default __webpack_public_path__ + "static/media/g_wdt_c_6.52c05f33.mp3";